import { gql } from './graphql';
// Mirrors dealroom-fe DealAutocomplete: fetch a page of deals via Get.getDealsTable,
// then client-side filter by name. The id field on getDealsTable items is the dealID.
export async function searchDeals(searchText) {
    const data = await gql(`query GetDealsTable($page: Int, $pageSize: Int) {
       Get {
         id: userID
         getDealsTable(page: $page, pageSize: $pageSize) {
           Items { id name }
         }
       }
     }`, { page: 0, pageSize: 1000 });
    const items = data?.Get?.getDealsTable?.Items ?? [];
    const q = searchText.trim().toLowerCase();
    const mapped = items.map((d) => ({ dealID: d.id, name: d.name }));
    return q ? mapped.filter((d) => d.name?.toLowerCase().includes(q)) : mapped;
}
export async function createDeal(name) {
    const data = await gql(`mutation CreateDeal($name: String!) {
       createDeal(name: $name) { dealID name }
     }`, { name });
    const d = data.createDeal;
    return { dealID: d.dealID ?? d.id, name: d.name };
}
